import { Route } from 'react-router-dom';
import { ONBOARDING } from '../../../constants/paths';

import { CrawlSwitch } from '../../../routers/crawl-switch';
import { PortAuditRevisionDetail } from '../../porting-hub/port-audit/PortAuditRevisionDetail';
import { PortingHubContainer } from '../../porting-hub-container/porting-hub.container';
import { PortOrder } from '../../porting-hub/port-order/port-order.component';
import { PortingDetail } from '../../porting-hub/porting-hub/porting-detail';
import { PortingHub } from '../../porting-hub/porting-hub/porting-hub';
import { OnboardingComponent } from '../onboarding-hub/onboarding-component';
import { AddEditHandoff } from './components/handoff-hub/edit-handoff/add-edit-handoff';
import { HandoffHub } from './components/handoff-hub/handoff-hub';
import { HandoffHubInfo } from './components/handoff-hub/handoff-hub-info';
import { IntakeFormComponentNew } from './components/intake-form-hub/intake-form-component';
import { FastPassPage } from '../fast-pass';

export const OnboardingHandoffRouter = () => {
  return (
    <CrawlSwitch>
      <Route path={ONBOARDING.onboarding} component={OnboardingComponent} />
      <Route path={ONBOARDING.intakeForm} component={IntakeFormComponentNew} />
      <Route path={ONBOARDING.porting} component={PortingHubContainer} />
      <Route path={ONBOARDING.portingV2AuditDetail} component={PortAuditRevisionDetail} />
      <Route path={ONBOARDING.portingV2CreateOrder} component={PortOrder} />
      <Route path={ONBOARDING.portingV2Detail} component={PortingDetail} />
      <Route path={ONBOARDING.portingV2} component={PortingHub} />
      <Route path={ONBOARDING.handoff} component={HandoffHub} exact />
      <Route path={ONBOARDING.createHandoff} component={AddEditHandoff} />
      <Route path={ONBOARDING.handoffHubInfo} component={HandoffHubInfo} />
      <Route path={ONBOARDING.fastPass} component={FastPassPage} />
    </CrawlSwitch>
  );
};
